import React, { useEffect, useState, useRef } from "react";
import Footerdeo from "../shared/Footerdeo";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import $ from "jquery";

function Totalapproved() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [approvedSchools, setApprovedSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApprovedData = async () => {
      setLoading(true); // Start loader
      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/ApprovedDEOListOfSchools_CL9`,
          {
            deO_ID: sessionStorage.getItem("deoId"),
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status === 200) {
          setApprovedSchools(response.data.data.deoSchools_list);
        } else {
          console.error("Unexpected response status:", response.data);
        }
      } catch (error) {
        console.error("Error fetching approved data:", error);
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchApprovedData();
  }, []);
  useEffect(() => {
    if (approvedSchools.length > 0) {
      const table = $(tableRef.current).DataTable({
        paging: true,
        searching: true,
        info: true,
        pageLength: 100,
        ordering: false,
        responsive: true,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });

      return () => table.destroy();
    }
  }, [approvedSchools]);

  return (
    <>
      <div className="container-scroller">
        <Navbardeo />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper">
          <Sidebardeo />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-12 col-md-6 mb-2 mb-md-0">
                      <h3 className="font-weight-bold">
                        Approved List Of Schools
                      </h3>
                    </div>
                    <div className="col-12 col-md-6 text-md-end">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-md-end mb-0 text-secondary">
                          <li className="breadcrumb-item">
                            <a
                              href="/deo-dashboard"
                              className="text-secondary text-decoration-none"
                            >
                              <i className="fa fa-tachometer me-1"></i>
                              Home
                            </a>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <table
                        ref={tableRef}
                        className="table table-condensed table-striped table-bordered"
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>Sl No.</th>
                            <th style={{ textAlign: "left" }}>School Code</th>
                            <th style={{ textAlign: "left" }}>School Name</th>
                            <th style={{ textAlign: "left" }}>Pin Code</th>
                            <th style={{ textAlign: "left" }}>Post Office</th>
                            <th style={{ textAlign: "left" }}>
                              No. of Students
                            </th>
                            <th style={{ textAlign: "left" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td
                                colSpan="7"
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : approvedSchools.length === 0 ? (
                            <tr>
                              <td colSpan="7" style={{ textAlign: "center" }}>
                                No schools found.
                              </td>
                            </tr>
                          ) : (
                            approvedSchools.map((school, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{school.schooL_CODE}</td>
                                <td>{school.schooL_NAME}</td>
                                <td>{school.piN_CODE}</td>
                                <td>{school.posT_OFFICE || "N/A"}</td>
                                <td>{school.nO_OF_STUDENT}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={() => {
                                      navigate("/total-approved-applicant", {
                                        state: { school },
                                      });
                                    }}
                                  >
                                    Check details{" "}
                                    <i className="fa-solid fa-angles-right"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footerdeo />
          </div>
        </div>
      </div>
    </>
  );
}

export default Totalapproved;
